import React from 'react';
import { Image } from '@popmenu/web-icons';
import { Box, Link, Typography } from '@popmenu/common-ui';
import { FormattedMessage } from 'react-intl';
import Grid from '~/shared/Grid';
import type { RootSiteTemplate } from '~/libs/gql/types';
import cn from 'classnames';
import useStyles from './styles';

type TemplateProps = {
  template?: RootSiteTemplate
  className?: string
}

const Template = ({ template, className }: TemplateProps) => {
  const classes = useStyles();
  return (
    <Grid
      item
      direction="column"
      alignItems="center"
      data-testid={`template-${template?.id}`}
      className={cn(className, classes.template)}
    >
      <Box
        display="flex"
        flexDirection="column"
        alignItems="flex-start"
        padding={0}
        flex={1}
      >
        <Typography variant="h6">{template?.name}</Typography>
        <Typography className="description">{template?.description}</Typography>
      </Box>
      {template?.screenshotUrl ? (
        <img
          className={classes.templateImage}
          src={template?.screenshotUrl}
          alt={template.name}
          loading="lazy"
        />
      ) : (
        <Image
          className={classes.templateImage}
        />
      )}
      <Link
        href={template?.restaurant?.popmenuUrl || '#'}
        target="_blank"
        className={classes.viewTemplateLink}
        rel="noopener noreferrer"
      >
        <FormattedMessage
          defaultMessage="View Template"
        />
      </Link>
    </Grid>
  );
};

export default Template;
